
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-assets-icons-bed_svg-icon-bed-clip0)"}},[_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M15.921 9.125H4.08c-1.697 0-3.079 1.4-3.079 3.12v4.781c0 .26.21.474.468.474a.472.472 0 00.467-.474v-1.831h16.13v1.831c0 .26.21.474.467.474a.472.472 0 00.468-.474v-4.781c0-1.72-1.382-3.12-3.079-3.12zm-13.986 3.12c0-1.199.963-2.173 2.144-2.173h11.84c1.183 0 2.144.976 2.144 2.173v2.002H1.935v-2.002z","fill":"#00467f"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M3.48 9.595c.264 0 .48-.25.48-.554V6.147c0-1.401.988-2.54 2.199-2.54h7.682c1.214 0 2.2 1.142 2.2 2.54v2.894c0 .304.215.554.48.554.263 0 .479-.25.479-.554V6.147c.002-2.01-1.415-3.647-3.159-3.647h-7.68C4.418 2.5 3 4.137 3 6.147v2.894c0 .307.216.554.48.554z","fill":"#00467f"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M12.927 9.46a.472.472 0 00.467-.474V6.962c0-.784-.629-1.421-1.403-1.421H8.008c-.774 0-1.403.637-1.403 1.421v2.024c0 .26.21.473.468.473a.472.472 0 00.468-.473V6.962c0-.26.21-.474.467-.474h3.981c.257 0 .468.214.468.474v2.024c.002.263.21.473.47.473z","fill":"#00467f"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-assets-icons-bed_svg-icon-bed-clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    